import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import { IWithT2sProducts } from "../../hoc/repository/withT2sProducts/withT2sProducts";
import theme from "../../theme";
import MiniProductsCarousel from "../MiniProductsCarousel";

const T2SCarousel = styled.div``;

const Title = styled.h2`
  text-align: center;
  margin: ${theme.margins.marginBig} auto;
  font-family: ${theme.fonts.granville};
  font-weight: 300;
  font-size: 22px;
  letter-spacing: 1.8px;
  line-height: 1.3;
  text-transform: uppercase;
  padding: 0 ${theme.margins.paddingPageBig};

  &:after {
    content: "";
    background-color: #000;
    width: 100%;
    max-width: 150px;
    height: 1px;
    display: block;
    margin: 10px auto 0 auto;
  }
`;

export interface IProps extends IWithT2sProducts {
  className?: string;
  title?: string;
  dots?: boolean;
  hasCustomPaging?: boolean;
}

export default class Target2SellCarousel extends PureComponent<IProps> {
  public static defaultProps: Partial<IProps> = {
    className: "",
  };

  public render(): ReactNode {
    const { className, title, dots, hasCustomPaging } = this.props;
    const products = this.props.t2sProducts;

    if (!products) {
      return null;
    }

    return (
      <T2SCarousel className={className}>
        {title && <Title>{title}</Title>}

        <MiniProductsCarousel
          products={products}
          onClick={this.props.onT2SProductClicked}
          dots={dots}
          hasCustomPaging={hasCustomPaging}
        />
      </T2SCarousel>
    );
  }
}
